import { c as _c } from "react/compiler-runtime";
import { Aiming, AlarmClock, ArrowLeft, ArrowRight, Attention, BalanceTwo, BookOpen, Box, Briefcase, Calculator, Calendar, Certificate, ChartLine, Check, CheckOne, CheckSmall, Close, CloseSmall, Comment, Copy, Delete, Diamond, DocDetail, DocSuccess, Dollar, Dot, Down, Download, DownSmall, Earth, Edit, ElectricDrill, EveryUser, Eyes, FileAddition, FileEditingOne, FileSearchTwo, FileSuccess, Funds, GoldMedal, HamburgerButton, Handbag, Help, Home, HorizontalTidyUp, Info, Key, Left, LeftSmall, Like, ListView, LocalTwo, Lock, Login, Logout, Mail, Me, Message, Minus, MoreOne, Parking, Percentage, PhoneTelephone, Plus, Refresh, Remind, Right, RightSmall, RightSmallUp, SaveOne, Search, SendOne, SettingConfig, SettingTwo, ShareOne, Shield, SortThree, SpeedOne, Star, ThumbsUp, Ticket, Time, Timer, Transaction, TrendingDown, TrendingUp, Undo, Unlock, Up, Upload, UpSmall, User, Wallet, Woman, Write } from "@icon-park/svg";
import { Icon as IconParkIcon, IIconProps } from "@icon-park/svg/lib/runtime";
import clsx from "clsx";
import { FC, useId } from "react";
import ChartLineDown from "./ChartLineDown";
import Document from "./Document";
import Documents from "./Documents";
import EqualSign from "./EqualSign";
import Euro from "./Euro";
import Eye from "./Eye";
import EyeOff from "./EyeOff";
import FacebookSquare from "./FacebookSquare";
import Feedback from "./Feedback";
import Filter from "./Filter";
import House from "./House";
import InstagramSquare from "./InstagramSquare";
import LinkedinSquare from "./LinkedinSquare";
import Partnership from "./Partnership";
import Reload from "./Reload";
import RocketTwo from "./RocketTwo";
import Sparkle from "./Sparkle";
import SquareMeter from "./SquareMeter";
import { ThermometerCold, ThermometerHot, ThermometerWarm } from "./Thermometer";
import TiktokSquare from "./TiktokSquare";
import WeighingScale from "./WeighingScale";
import Whatsapp from "./Whatsapp";
import WhatsappSquare from "./WhatsappSquare";
export { Comment, Document, Documents, Download, Euro, Eye, EyeOff, FacebookSquare, Feedback, FileSuccess, Filter, Partnership, Reload, RightSmall, RightSmallUp, RocketTwo, Shield, Sparkle, SquareMeter, Star, ThermometerCold, ThermometerHot, ThermometerWarm, TiktokSquare, Upload, Whatsapp, WhatsappSquare };
/**
 * All bundled icons. Add new icons here if necessary.
 */
const includedIcons = {
  Aiming,
  AlarmClock,
  ArrowRight,
  ArrowLeft,
  TrendingUp,
  TrendingDown,
  Attention,
  BalanceTwo,
  BookOpen,
  Box,
  Briefcase,
  Calculator,
  Calendar,
  Certificate,
  ChartLine,
  ChartLineDown,
  Check,
  CheckOne,
  CheckSmall,
  Close,
  CloseSmall,
  Comment,
  Copy,
  Delete,
  Diamond,
  DocDetail,
  DocSuccess,
  Document,
  Documents,
  Dollar,
  Download,
  Dot,
  Down,
  Earth,
  Edit,
  ElectricDrill,
  EqualSign,
  Euro,
  EveryUser,
  Eye,
  EyeOff,
  Eyes,
  FacebookSquare,
  Feedback,
  Filter,
  FileAddition,
  FileEditingOne,
  FileSuccess,
  FileSearchTwo,
  Funds,
  GoldMedal,
  HamburgerButton,
  Handbag,
  Help,
  Undo,
  Unlock,
  Home,
  House,
  HorizontalTidyUp,
  Info,
  InstagramSquare,
  Key,
  Left,
  LeftSmall,
  Like,
  LinkedinSquare,
  ListView,
  LocalTwo,
  Lock,
  Login,
  Logout,
  Mail,
  Me,
  Message,
  Minus,
  MoreOne,
  Parking,
  Partnership,
  Percentage,
  PhoneTelephone,
  Plus,
  Refresh,
  Reload,
  Remind,
  Right,
  RightSmall,
  RightSmallUp,
  RocketTwo,
  SaveOne,
  Search,
  SendOne,
  SettingConfig,
  SettingTwo,
  ShareOne,
  SortThree,
  Sparkle,
  SpeedOne,
  SquareMeter,
  ThermometerCold,
  ThermometerWarm,
  ThermometerHot,
  ThumbsUp,
  Ticket,
  TiktokSquare,
  Time,
  Timer,
  Transaction,
  Up,
  UpSmall,
  DownSmall,
  User,
  Wallet,
  WeighingScale,
  Whatsapp,
  WhatsappSquare,
  Woman,
  Write,
  Upload,
  Star,
  Shield
} satisfies Record<string, IconParkIcon>;
export type IconType = keyof typeof includedIcons;

/**
 * The bundled names at runtime, and a guard for them.
 *
 * `IconType` only helps where the name is written in the source. A name that arrives from a
 * CMS is a string until something checks it, and `Icon` renders nothing for one it does not
 * know - so a typo in an editor's field becomes a hole in the page with no error anywhere.
 */
export const iconTypes = Object.keys(includedIcons) as IconType[];
export const isIconType = (name?: string | null): name is IconType => !!name && Object.prototype.hasOwnProperty.call(includedIcons, name);
export interface IconProps extends IIconProps {
  type?: IconType;
  icon?: IconParkIcon;
  className?: string;
}

/**
 * This is a wrapper for the icon park icon library.
 * The purpose of this component is to have the ability to dynamically include icons from a specified set of icons, without loading the whole icon library (2000+ icons).
 */
// icon-park appends an 8-character suffix to a random id per render, which breaks hydration.
const withStableId = (svg: string, stableId: string) => {
  const randomId = /id="(icon-[0-9a-f]*)[0-9a-f]{8}"/.exec(svg)?.[1];
  return randomId ? svg.replaceAll(randomId, stableId) : svg;
};
const Icon: FC<IconProps> = t0 => {
  const $ = _c(11);
  const {
    icon,
    type,
    className,
    ...props
  } = t0;
  const t1 = useId();
  let t2;
  if ($[0] !== t1) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /[^a-zA-Z0-9]/g;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    t2 = t1.replace(t3, "");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const stableId = `icon-${t2}-`;
  const iconParkIcon = icon ?? (type && includedIcons[type]);
  if (!iconParkIcon) {
    return null;
  }
  const t3 = type === "Login" || type === "Logout";
  let t4;
  if ($[3] !== className || $[4] !== t3) {
    t4 = clsx("inline-block", className, {
      "rotate-180": t3
    });
    $[3] = className;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = withStableId(iconParkIcon(props), stableId);
  let t6;
  if ($[6] !== t5) {
    t6 = {
      __html: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <span className={t4} dangerouslySetInnerHTML={t6} />;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
export default Icon;